import { z } from "zod";

const jsonField = z.string().refine((val) => {
  if (!val.trim()) return true;
  try { JSON.parse(val); return true; } catch { return false; }
}, "Binding must be valid JSON");

export const calculationParameterSchema = z.object({
  id: z.string().min(1, "ID is required"),
  label: z.string().min(1, "Label is required"),
  group: z.string().min(1, "Group is required"),
  value: z.string().min(1, "Value is required"),
  unit: z.string().optional(),
  note: z.string().optional(),
  binding: jsonField,
});

export type CalculationParameterFormData = z.infer<typeof calculationParameterSchema>;
